import { render, staticRenderFns } from "./ViewTicket.vue?vue&type=template&id=aa74f396&"
import script from "./ViewTicket.vue?vue&type=script&lang=ts&"
export * from "./ViewTicket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports